
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.872 5.777v10.499a3.285 3.285 0 00-1.932-.612c-1.674 0-3.036 1.197-3.036 2.668S5.266 21 6.94 21s3.036-1.197 3.036-2.668V9.217l9.015-2.23v6.785a3.285 3.285 0 00-1.932-.611c-1.674 0-3.035 1.197-3.035 2.668 0 1.47 1.362 2.667 3.035 2.667 1.674 0 3.036-1.196 3.036-2.667V2.998L8.872 5.778z","fill":"#282E3E"}})])
          )
        }
      }
    